import React from 'react';
import { ComingSoonPage } from './ComingSoonPage';

function PoliciesPage() {
  return (
    <ComingSoonPage
      label="Governance"
      title="Policies"
      description="Release approval workflows and workspace governance."
      planned={[
        'Require approval from N admins before deploying to production',
        'Per-target deployment rules (who can deploy to each environment)',
        'Policy change audit history',
      ]}
    />
  );
}

export { PoliciesPage };
